import { fetchClientsFrotixPneus, setStatusFrotixPneus } from "@/api/atendimentos";

const state = {
  isLoading: false,
  clients: [],
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchClientsFrotixPneus({ dispatch, commit }) {
    try {
      dispatch("overlay/show", true, { root: true });

      const clients = await fetchClientsFrotixPneus();

      commit("setClients", clients);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async setStatusFrotixPneus({ dispatch }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      await setStatusFrotixPneus(payload)

      return true
    } catch (error) {
      console.log('[ERROR-SET-STATUS-FROTIX-PNEUS] =>', error)

      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },
};

const mutations = {
  cleanState(state) {
    state.isLoading = false;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  setClients(state, clients) {
    state.clients = clients;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
